import { type FC, useState, useEffect, type PropsWithChildren } from 'react'
import { Capacitor } from '@capacitor/core'
import { type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { Logger } from '@egw/logger'
import { lt } from 'semver'
import { getCurrentAppVersion } from '../../services'

const log = new Logger('Force Update Service')

export const ForceUpdate: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [currentVersion, setCurrentVersion] = useState('')
  const { flags } = useFlags<FeatureFlags>()

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      void getCurrentAppVersion()
        .then((version) => {
          setCurrentVersion(version)
        })
        .catch((error: unknown) => {
          log.error('Error getting current app version:', error)
        })
    }
  }, [])

  useEffect(() => {
    if (flags.latestStableVersion !== '' && currentVersion !== '' && Capacitor.isNativePlatform()) {
      if (lt(currentVersion, flags.latestStableVersion)) {
        setIsOpen(true)
      } else {
        setIsOpen(false)
      }
    }
  }, [flags.latestStableVersion, currentVersion])

  return isOpen ? children : null
}
